/**
 * @generated SignedSource<<88f29b7252b64200dee3e1c0eaae6f41>>
 * @relayHash 7bcbd912ac7acfb1b4c4b836ba3a28e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f0839ddac435a5fe5c2ea4a22aa186886671df16285c4860a7b02e9942a48a2a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

import isICCHarmonisationBacklogEnabled_provider from '@atlassian/jira-relay-provider/src/icc-harmonisation-backlog.relayprovider';
import isJiraAiAgentAvatarFilterComponentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-filter-component.relayprovider';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f0839ddac435a5fe5c2ea4a22aa186886671df16285c4860a7b02e9942a48a2a",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider": isJiraAiAgentAvatarFilterComponentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrciccharmonisationbacklogrelayprovider": isICCHarmonisationBacklogEnabled_provider
    }
  }
};

export default node;
